<template>
<div id="newsletter" class=" bg-alt border-alt-b">
    <div class="row m-3 m-md-6 center" v-show="!submitted">
		<div class="col-12 col-md-6 col-lg-4 col-xl-3 offset-0 p-0 pr-md-3">
			<div class="right-inner-addon mb-3 mb-md-0">
				<input type="text" name="email" class="form-control text-center box py-2" :class="{'is-invalid': errors.hasOwnProperty('email')}" placeholder="Email Address" v-model="form.email" @keydown="onInput">
				<span v-if="errors.hasOwnProperty('email')" class="small text-danger" area-hidden='true'>
					{{ errors.email[0] }}
				</span>
			</div>
		</div>
		<div class="col-12 col-md-6 col-lg-4 col-xl-3 offset-0 p-0 pl-md-3">
			<button type="submit" class="btn btn-block btn-secondary bg-alt-red border-danger text-white py-2 text-bold" @click="submit">Join Our Newsletter <i class="fas fa-chevron-circle-right text-white ml-2"></i></button>
		</div>
    </div>
	<div class="my-5 d-flex center" v-if="message != ''">
		<h5 class="m-0" v-text="message"></h5>
	</div>
</div><!-- /newsletter -->
</template>

<script>
import axios from 'axios'

export default {
	name: 'newsletter',
	data() {
		return {
			form: {
				website: 'hsol',
				email: ''
			},
			submitted: false,
			message: '',
			errors: {}
		}
	},
	methods: {
		onInput(e) {
			if (
				typeof this.errors === 'object' &&
				this.errors.hasOwnProperty(e.target.name)
			) {
				delete this.errors[e.target.name]
			}
		},
		submit() {
			axios
				.post(process.env.UNIVERSAL + '/api/subscribe', this.form, {
					headers: {
						'X-Requested-With': 'XMLHttpRequest',
						Accept: 'application/json',
						'Content-Type': 'application/json'
					}
				})
				.then(({ data: { message } }) => {
					this.message = message
					this.submitted = true
				})
				.catch(({ response: { data: { errors } } }) => {
					this.errors = errors
				})
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/home/Newsletter.vue